import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

type CaymaFormState = {
  orderDate: string;
  deliveryDate: string;
  productName: string;
  productCode: string;
  quantity: string;
  invoiceNo: string;
  price: string;
  fullName: string;
  address: string;
  phone: string;
  email: string;
  declarationDate: string;
  signatureName: string;
};

const initialCaymaForm: CaymaFormState = {
  orderDate: '',
  deliveryDate: '',
  productName: '',
  productCode: '',
  quantity: '',
  invoiceNo: '',
  price: '',
  fullName: '',
  address: '',
  phone: '',
  email: '',
  declarationDate: '',
  signatureName: '',
};

function useCaymaFormMailto(form: CaymaFormState) {
  return useMemo(() => {
    const body = [
      'CAYMA FORMU',
      '',
      '1) Kime:',
      'Unvan: BALIKESİR GÜVEN ÖZEL SAĞLIK LABORATUVAR HİZMETLERİ LTD. ŞTİ.',
      'Adres: Bahçelievler Mah. Atatürk Cad. Erdem Sitesi No: 10 B Altıeylül / Balıkesir',
      'Telefon: +90 553 538 24 62',
      'E-posta: guvenozelsaglik@gmail.com',
      'KEP: balikesirguvenozel@hs06.kep.tr',
      '',
      `2) Sipariş Tarihi: ${form.orderDate}`,
      `3) Ürünün Teslim Alındığı Tarih: ${form.deliveryDate}`,
      '4) Cayma Hakkına Konu Ürün:',
      `Ürün Adı: ${form.productName}`,
      `Model / Ürün Kodu: ${form.productCode}`,
      `Adet: ${form.quantity}`,
      `5) Sipariş / Fatura No: ${form.invoiceNo}`,
      `6) Ürün Bedeli: ${form.price} TL`,
      `7) Alıcının Adı Soyadı / Unvanı: ${form.fullName}`,
      `8) Alıcının Adresi: ${form.address}`,
      `9) Alıcının Telefonu: ${form.phone}`,
      `10) Alıcının E-posta Adresi: ${form.email}`,
      '',
      '11) Cayma Beyanı:',
      'Yukarıda bilgileri belirtilen ürün/ürünlere ilişkin mesafeli satış sözleşmesinden, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve ilgili mevzuat kapsamında cayma hakkımı kullanmak istediğimi bildiririm.',
      '',
      `Tarih: ${form.declarationDate}`,
      `Alıcının Adı Soyadı: ${form.signatureName}`,
    ].join('\n');

    return `mailto:guvenozelsaglik@gmail.com?subject=${encodeURIComponent('Cayma Formu')}&body=${encodeURIComponent(body)}`;
  }, [form]);
}

export default function CaymaFormPage() {
  const [form, setForm] = useState<CaymaFormState>(initialCaymaForm);
  const mailto = useCaymaFormMailto(form);

  const update = (field: keyof CaymaFormState, value: string) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  return (
    <div className="container legal-page">
      <nav className="legal-breadcrumb">
        <Link to="/">Ana Sayfa</Link>
        <span>/</span>
        <span>Cayma Formu</span>
      </nav>

      <header className="legal-header">
        <h1>Cayma Formu</h1>
        <p>
          Bu form, yalnızca mesafeli satış sözleşmesinden cayma hakkının kullanılması
          amacıyla doldurularak satıcıya iletilebilir.
        </p>
      </header>

      <form className="legal-content cayma-form" onSubmit={(event) => event.preventDefault()}>
        <section className="legal-section">
          <h2>1) Kime</h2>
          <dl className="legal-contact">
            <div className="legal-contact-row">
              <dt>Unvan</dt>
              <dd>BALIKESİR GÜVEN ÖZEL SAĞLIK LABORATUVAR HİZMETLERİ LTD. ŞTİ.</dd>
            </div>
            <div className="legal-contact-row">
              <dt>Adres</dt>
              <dd>Bahçelievler Mah. Atatürk Cad. Erdem Sitesi No: 10 B Altıeylül / Balıkesir</dd>
            </div>
            <div className="legal-contact-row">
              <dt>Telefon</dt>
              <dd>
                <a href="tel:+905535382462">+90 553 538 24 62</a>
              </dd>
            </div>
            <div className="legal-contact-row">
              <dt>E-posta</dt>
              <dd>
                <a href="mailto:guvenozelsaglik@gmail.com">guvenozelsaglik@gmail.com</a>
              </dd>
            </div>
            <div className="legal-contact-row">
              <dt>KEP</dt>
              <dd>
                <a href="mailto:balikesirguvenozel@hs06.kep.tr">balikesirguvenozel@hs06.kep.tr</a>
              </dd>
            </div>
          </dl>
        </section>

        <section className="legal-section">
          <div className="form-grid">
            <label className="form-group">
              <span>2) Sipariş Tarihi</span>
              <input type="date" value={form.orderDate} onChange={(e) => update('orderDate', e.target.value)} />
            </label>
            <label className="form-group">
              <span>3) Ürünün Teslim Alındığı Tarih</span>
              <input type="date" value={form.deliveryDate} onChange={(e) => update('deliveryDate', e.target.value)} />
            </label>
          </div>
        </section>

        <section className="legal-section">
          <h2>4) Cayma Hakkına Konu Ürün</h2>
          <div className="form-grid">
            <label className="form-group">
              <span>Ürün Adı</span>
              <input value={form.productName} onChange={(e) => update('productName', e.target.value)} />
            </label>
            <label className="form-group">
              <span>Model / Ürün Kodu</span>
              <input value={form.productCode} onChange={(e) => update('productCode', e.target.value)} />
            </label>
            <label className="form-group">
              <span>Adet</span>
              <input value={form.quantity} onChange={(e) => update('quantity', e.target.value)} />
            </label>
          </div>
        </section>

        <section className="legal-section">
          <div className="form-grid">
            <label className="form-group">
              <span>5) Sipariş / Fatura No</span>
              <input value={form.invoiceNo} onChange={(e) => update('invoiceNo', e.target.value)} />
            </label>
            <label className="form-group">
              <span>6) Ürün Bedeli (TL)</span>
              <input value={form.price} onChange={(e) => update('price', e.target.value)} />
            </label>
          </div>
        </section>

        <section className="legal-section">
          <div className="form-grid">
            <label className="form-group">
              <span>7) Alıcının Adı Soyadı / Unvanı</span>
              <input value={form.fullName} onChange={(e) => update('fullName', e.target.value)} />
            </label>
            <label className="form-group">
              <span>9) Alıcının Telefonu</span>
              <input value={form.phone} onChange={(e) => update('phone', e.target.value)} />
            </label>
            <label className="form-group">
              <span>10) Alıcının E-posta Adresi</span>
              <input type="email" value={form.email} onChange={(e) => update('email', e.target.value)} />
            </label>
            <label className="form-group form-group-full">
              <span>8) Alıcının Adresi</span>
              <textarea rows={3} value={form.address} onChange={(e) => update('address', e.target.value)} />
            </label>
          </div>
        </section>

        <section className="legal-section">
          <h2>11) Cayma Beyanı</h2>
          <p>
            Yukarıda bilgileri belirtilen ürün/ürünlere ilişkin mesafeli satış sözleşmesinden,
            6502 sayılı Tüketicinin Korunması Hakkında Kanun ve ilgili mevzuat kapsamında cayma
            hakkımı kullanmak istediğimi bildiririm.
          </p>
          <div className="form-grid">
            <label className="form-group">
              <span>Tarih</span>
              <input type="date" value={form.declarationDate} onChange={(e) => update('declarationDate', e.target.value)} />
            </label>
            <label className="form-group">
              <span>Alıcının Adı Soyadı</span>
              <input value={form.signatureName} onChange={(e) => update('signatureName', e.target.value)} />
            </label>
          </div>
        </section>

        <div className="cayma-form-actions">
          <a href={mailto} className="btn btn-primary">
            E-posta ile Gönder
          </a>
          <Link to="/yasal/iptal-iade-kosullari" className="btn btn-outline">
            İptal ve İade Koşulları
          </Link>
        </div>
      </form>
    </div>
  );
}
